import React, { ReactNode } from 'react'
import { Layout } from './Layout'
import { useProps } from './useProps'

type Props = {
  children: ReactNode
}

export const AgreementProvider: React.FC<Props> = ({ children }) => {
  return <Layout {...useProps({ children })} />
}
